<template>
  <div class="list-contain-mall">
    <van-pull-refresh class="goods-contain" v-model="refreshing" @refresh="onRefresh">
      <!-- 没有更多了 -->
      <van-list class="list" v-model="loading" @load="onLoad" :finished="finished" :offset="10" :finished-text="goodsList.length > 0 ? '' : '没有更多了'" :error.sync="error" error-text="请求失败，点击重新加载">
        <!-- //code类型：1 加息券 2 代金券 3 京东E卡 4 盒马鲜生 5 黑猪礼品卡 -->
        <van-grid column-num="2" gutter="10" :center="false">
          <van-grid-item v-for="item of goodsList" :key="item.id">
            <template #default>
              <!-- //code类型：1 加息券 2 代金券 3 京东E卡 4 盒马鲜生 5 黑猪礼品卡 -->
              <div class="item-bg" @click="clickGoodsItem(item)">
                <div class="img-bg">
                  <img class="goods-pictur" :src="item.coverImg" fit="cover" alt="商品图片" />
                  <div v-if="item.goodsLabel" class="coupon-tag-bg">
                    <van-tag class="coupon-tag">{{ item.goodsLabel }}</van-tag>
                  </div>
                </div>
                <div class="right-bg">
                  <div class="goods-title">
                    <img v-if="item.label" style="height: 14px; vertical-align: middle" :src="item.label" />
                    <span style="vertical-align: middle" :style="item.label ? 'padding-left:5px' : 'padding-left:0px'">{{ item.typeName }}&nbsp; {{ item.title }}</span>
                  </div>
                  <div class="integral-amount">
                    <template v-if="item.code == 2">
                      <template v-if="item.rate">
                        <span class="unit">折后价:</span>
                        <span>{{ getAmountAndIntegral(item).score }}</span>
                        <span class="unit">积分</span>
                      </template>
                      <template v-else>
                        <span>{{ getAmountAndIntegral(item).score }}</span>
                        <span class="unit">积分</span>
                      </template>
                    </template>
                    <template v-else>
                      <template v-if="getAmountAndIntegral(item).onlyScore">
                        <span>{{ getAmountAndIntegral(item).score }}</span>
                        <span class="unit">积分</span>
                      </template>
                      <template v-else>
                        <span>{{ getAmountAndIntegral(item).price }}</span>
                        <template v-if="getAmountAndIntegral(item).score > 0">
                          <span class="unit">起 + 积分</span>
                        </template>
                        <template v-else>
                          <span class="unit">元</span>
                        </template>
                      </template>
                    </template>
                  </div>
                  <div class="price-redee">
                    <div class="price">
                      <template v-if="item.code == 2">
                        <template v-if="item.rate">
                          <span class="originalPrice">市场价:{{
                          (
                            (item.marketPrice || 0) *
                            userInfo.scoreExchangeRate
                          ).toFixed(0)
                        }}积分</span>
                        </template>
                      </template>
                      <template v-else>
                        <template v-if="item.rate">
                          <span class="originalPrice">市场价:{{ (item.marketPrice || 0).toFixed(0)
                        }}{{ item.unit }}</span>
                          <span>&nbsp;&nbsp;</span>
                          <span class="ratePrice">折后价:{{ (item.price / 100 || 0).toFixed(1)
                        }}{{ item.unit }}</span>
                        </template>
                        <template v-else>
                          <span class="ratePrice">市场价:{{ (item.marketPrice || 0).toFixed(1)
                        }}{{ item.unit }}</span>
                        </template>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </van-grid-item>
        </van-grid>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import { Cell, Icon, Image, List, PullRefresh, Tag, Grid, GridItem } from "vant"
import * as MallApi from "@/api/mall"
import { mapActions, mapGetters } from "vuex"
export default {
  components: {
    [Icon.name]: Icon,
    [Image.name]: Image,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
  },
  props: {
    itemObj: {},
    mallList: undefined,
    categoryId: ""
  },
  data() {
    return {
      refreshing: false,
      finished: false,
      loading: false,
      error: false,
      params: {
        pageNo: 1,
        pageSize: 10,
        pageType: 1,
        classifiesId: ""
      },
      goodsList: [], //精选商品集合
      isTemplateData: false
    }
  },
  computed: {
    ...mapGetters(["mallCategory"])
  },
  watch: {
    mallCategory: function (val) {
      if (val) {
        this.params.classifiesId = ""
      } else {
        this.params.classifiesId = this.itemObj.id
      }
      this.onRefresh()
    }
  },
  beforeMount() {
    if (this.mallList) {
      this.finished = true
      this.isTemplateData = true
      this.goodsList = this.mallList
    } else {
      if (this.itemObj) {
        this.params.classifiesId = this.mallCategory ? "" : this.itemObj.id
      }
    }
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    getAmountAndIntegral(item) {
      let price =
        item.price / 100 - item.score / this.userInfo.scoreExchangeRate
      if (price > 0) {
        return { onlyScore: false, score: item.score, price: price.toFixed(1) }
      } else {
        return { onlyScore: true, score: item.score }
      }
    },
    onRefresh() {
      //清空列表数据
      // this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      // this.loading = true
      if (this.isTemplateData) {
        this.refreshing = false
      } else {
        this.params.pageNo = 1
        this.onLoad()
      }
    },
    onLoad() {
      MallApi.getGoodsList(this.params)
        .then((data) => {
          this.error = false
          if (data) {
            this.loading = false
            if (this.params.pageNo === 1) {
              this.finished = false
              this.goodsList = data.list
              //赋值给数据源
            } else {
              this.goodsList = this.goodsList.concat(data.list)
            }
            if (data.list.length < this.params.pageSize) {
              this.finished = true
            } else {
              this.params.pageNo++
            }
            this.refreshing = false
          }
        })
        .catch((e) => {
          this.loading = false
          this.error = true
          this.refreshing = false
          this.$toast(e.msg || e.message)
        })
    },
    clickGoodsItem(item) {
      this.$router.push({
        name: "productDetails",
        query: {
          goodId: item.id,
          categoryId: this.categoryId,
          noshowHome: true
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.list-contain-mall {
  margin: 0;
  background-color: transparent;
  .goods-contain .list .cell {
    margin: 0;
    padding: 0;
    margin-bottom: 10px;
    background-color: transparent;
  }
  .goods-contain .list {
    background-color: transparent;
    margin: 10px 0 0 0;
    ::v-deep .van-grid-item__content,
    .van-grid-item__content--center,
    .van-grid-item__content--surround,
    .van-hairline {
      padding: 0;
      border-radius: 10px;
    }
    .item-bg {
      border-radius: 10px;
      padding: 0px;
      background-color: white;
      overflow: hidden;
      .img-bg {
        width: 100%;
        height: 215px;
        .goods-pictur {
          object-fit: fill;
          width: 100%;
          height: 100%;
        }
        .coupon-tag-bg {
          overflow: hidden;
          position: absolute;
          top: 0px;
          right: 0;
          height: 50%;
          display: flex;
          flex-direction: column;
          align-items: center;
          .coupon-tag {
            margin-top: 10px;
            margin-right: -35px;
            min-width: 120px;
            justify-content: center;
            text-align: center;
            transform: rotate(35deg);
            background-color: rgba(249, 196, 129, 1);
            height: 30px;
            text-align: center;
            color: red;
            font-size: 10px;
            font-weight: 700;
          }
        }
      }
      .right-bg {
        padding: 10px;
        .goods-title {
          text-align: left;
          color: rgb(26, 26, 26);
          font-size: 13px;
          font-weight: 500;
          overflow: hidden;
          word-wrap: break-word;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          line-clamp: 2;
          -webkit-line-clamp: 2;
        }
        .integral-amount {
          color: rgb(233, 0, 37);
          font-size: 20px;
          .unit {
            font-size: 10px;
          }
        }
        .price-redee {
          width: 100%;
          display: flex;
          justify-content: space-between;
          .price {
            font-size: 11px;
            color: rgb(118, 118, 118);
            .originalPrice {
              text-decoration: line-through;
            }
            .ratePrice {
              color: rgb(51, 51, 51);
            }
          }
        }
      }
    }
  }
}
</style>